export enum UpdaterEvents {
  /** 检测更新 */
  UPDATE_CHECK = 'UPDATE-CHECK',
  /** 需要更新 */
  UPDATE_AVAILABLE = 'update-available',
  /** 开始更新 */
  UPDATE_START = 'update-start',
  /** 更新进度 */
  UPDATE_PROGRESS = 'update-progress',
  /** 更新取消 */
  UPDATE_CANCEL = 'update-cancel',
  /** 更新完成 */
  UPDATE_COMPLETED = 'update-completed',
  /** 安装并重启 */
  UPDATE_INSTALL = 'update-install'
}

export enum UpdateFlags {
  /** 强制更新 */
  FORCE = 2
}

export enum UpdateStatus {
  /** 需要更新 */
  AVAILABLE = 0,
  /** 更新下载中 */
  DOWNLOADING = 1,
  /** 更新完成 */
  COMPLETED = 2,
}
